import React from 'react';
import SarasWrapper from '../../container/SarasWrapper'
import SarasMenu from '../../repeater/menu/SarasMenu'
import SarasFormMenuRow from '../../repeater/menu/SarasFormMenuRow'
import ActionButton from '../../input/buttons/button/SarasButton2';
import SarasConfirmPrompt from "../../notifications/SarasConfirmPrompt";
import SarasTrans from "../../notifications/SarasTrans"

const FormStatus = (props) => {
    const { formObject, action, rowKey, headerKey, className, customWrapper, wrapperClass, ...restProps } = props;

    const [confirmPromptData,setConfirmPromptData] = React.useState({})
    const viewData = formObject.getFormRow(rowKey, headerKey);
    const statusStyle = JSON.parse(formObject.getValueFromKey(viewData, "rowValues.docStatus.dataList.style", "{}"));
    
    const renderFormMenu = () => {
        //const MenuIcon = Icon[icon];
        return (
            <ActionButton className='uiContextMenu'  {...restProps} />
        )
    }

    const onMenuItemCLick = (e, value) => {
        // console.log("form button clicked");
        if(value)
        {
            let selectedItem = getSelectedRow(value);
            let promptMsg = `Change status to ${selectedItem.valF}?`
            setConfirmPromptData({message:promptMsg, callback:() => {executeStatusChangeAction(e, value)}});
        }
        else{
            executeStatusChangeAction(e, value)
        }
    }

    const getSelectedRow = (value) => {
        if (value) {
            // let selectedItem = menuList[value];
            // if (!selectedItem)
            let selectedItem = menuList[Object.keys(menuList)[value]]
            return selectedItem
        }
    }

    const executeStatusChangeAction = (e, value) => {
        let SelectedItem = getSelectedRow(value);
        let datalist = SelectedItem.dataList;
        var actionParam = formObject.convertStrToKeyValue(datalist.actionParam)
        let customAction = { actionId: datalist.actId, isCompHeader: action ? action.isCompHeader : 0,  actionParam: { ...actionParam }, refreshMode:"parent"}
        formObject.onFormAction(customAction, rowKey, headerKey);
    }

    const renderMenu = () => {
        let list = Object.values(menuList);
        if (rowValues.docProcessAction.dataList.isHid === "0" && list.length > 0) {
            return (
                <SarasMenu menuTrigger={renderFormMenu()}
                    dataList={list}
                    menuItem={SarasFormMenuRow} onSelection={onMenuItemCLick}
                />
            )
        }
        else
            return (null)
    }
    //            <sarasTrans value={} />
    if (!viewData)
        return (null)

    const rowValues = viewData.rowValues;
    const menuList = viewData.rowValues.docStatus.childRows[0].rowValues;
    return (
        <SarasWrapper customWrapper={customWrapper}>
            <SarasConfirmPrompt promptData={confirmPromptData} />
            <span className="uiChip" style={statusStyle}>
                <SarasTrans value={rowValues.docStatus.val} />
            </span>
            {renderMenu()}
        </SarasWrapper>
    )
}

export default FormStatus